<div>
  <div class="py-4">
    <p class="text-grey-700 text-sm">{{ 'region.title' | transloco }}</p>
    @if (regions$ | async; as regions) {
      <p-select appendTo="body" class="w-full" [options]="(options$ | async) ?? []" optionLabel="name" [ngModel]="selectedOption$.value" (ngModelChange)="selectedOption$.next($event)" (onChange)="setSelectedRegion($event, regions)"></p-select>
    }
  </div>
  <div class="flex bg-grey-bg border-t border-grey-300 pt-4 mt-4 -mb-5 -mx-5 w-[calc(100%+--spacing(10))] pr-4 pb-4">
    <button class="bg-jcb font-bold text-sm text-grey-800 px-6 py-2 ml-auto rounded-sm cursor-pointer" (click)="updateRegion()">{{ 'region.confirmBtn' | transloco }}</button>
  </div>
</div>
